import {
  DangerousGoodsStackingRuleDto,
  DangerousGoodsStackingRulesApi,
  DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest,
} from '@storage/app/api'

export class DGStackingRuleService {
  constructor(private api: DangerousGoodsStackingRulesApi) {}

  async getAll(): Promise<Array<DangerousGoodsStackingRuleDto>> {
    const { data: dbStackingRules } = await this.api.dangerousGoodsStackingRulesGetAll()
    return dbStackingRules
  }

  async updatePrimaryImoClassStackingRule(
    request: DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest,
  ): Promise<void> {
    await this.api.dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule(request)
  }

  async updateSecondaryImoClassStackingRule(
    request: DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest,
  ): Promise<void> {
    await this.api.dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule(request)
  }
}
